module.exports = __webpack_public_path__ + "media/common/statics/lesson_icon/1-8e3ad69dea408aff4e16d71f1b9421be.png";